import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs';

const getMeasurements = (merchantId) => {
	return Client.get(`${baseUrl}/manage-point/${merchantId}/measurements`);
};

const getPointMeasurements = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/manage-mdse-point/${merchantId}/measurements`,
		data
	);
};

const putPointMeasurements = (merchantId, measurementId, data) => {
	return Client.put(
		`${baseUrl}/manage-mdse-point/${merchantId}/measurements/${measurementId}`,
		data
	);
};

const postPointMeasurements = (merchantId, data) => {
	return Client.post(
		`${baseUrl}/manage-mdse-point/${merchantId}/measurements`,
		data
	);
};

const delPointMeasurements = (merchantId, measurementId) => {
	return Client.del(
		`${baseUrl}/manage-mdse-point/${merchantId}/measurements/${measurementId}`
	);
};

export default {
	getMeasurements,
	getPointMeasurements,
	putPointMeasurements,
	postPointMeasurements,
	delPointMeasurements,
};
